import { useNavigate } from "react-router-dom";
import { addDays, format, parseISO } from "date-fns";
import { toISO, todayISO, fmtTime } from "@/lib/format";
import { useSettings } from "@/context/SettingsContext";
import { jobTypeColor, textOn } from "@/lib/jobTypes";
import { cn } from "@/lib/utils";

export const JobChip = ({ j, compact }) => {
  const navigate = useNavigate();
  const { settings } = useSettings();
  const color = jobTypeColor(settings.job_types, j.job_type);
  return (
    <button onClick={(e) => { e.stopPropagation(); navigate(`/bookings/${j.id}`); }} data-testid={`calendar-job-${j.id}`}
      className={cn("block w-full rounded px-1.5 py-1 text-left text-[11px] leading-tight shadow-sm transition-opacity hover:opacity-85", j.status === "Hold" && "border border-dashed border-white/70")}
      style={{ background: color, color: textOn(color) }} title={`${j.job_number} | ${j.customer_name} | ${j.job_type || "No route"} | ${fmtTime(j.start_time)}`}>
      <span className="font-mono font-bold">{j.job_number}</span> <span className="font-medium">{j.customer_name}</span>
      {!compact && <div className="truncate opacity-90">{j.job_type || "No route"} · {fmtTime(j.start_time)}</div>}
    </button>
  );
};

export const WeekView = ({ start, days, onSelectDay }) => {
  const today = todayISO();
  const cols = Array.from({ length: 7 }, (_, i) => toISO(addDays(parseISO(start), i)));
  return (
    <div className="grid grid-cols-1 gap-2 md:grid-cols-7" data-testid="calendar-week">
      {cols.map((iso) => {
        const info = days[iso];
        return (
          <div key={iso} className={cn("rounded-xl border border-slate-200 bg-white p-2", iso === today && "border-[#FACC15]")} data-testid={`week-day-${iso}`}>
            <button onClick={() => onSelectDay(iso)} className="mb-2 flex w-full items-baseline justify-between rounded px-1 text-left hover:bg-slate-50" data-testid={`week-day-open-${iso}`}>
              <span className="text-xs font-semibold uppercase text-slate-500">{format(parseISO(iso), "EEE")} <span className="text-slate-900">{format(parseISO(iso), "d")}</span></span>
              <span className="font-mono text-xs font-bold text-slate-700">{info?.count || 0}</span>
            </button>
            <div className="space-y-1">
              {(info?.jobs || []).map((j) => <JobChip key={j.id} j={j} />)}
              {!info?.jobs?.length && <div className="py-4 text-center text-xs text-slate-300">—</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};
